import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types';

export const updateImageDocumentInDictAction = (
  state: ImageHandlingState,
  action: PayloadAction<{ documentId: number; updatedImageDocument: ImageDocumentStoreItem }>
) => {
  const { documentId, updatedImageDocument } = action.payload;
  state.imagesDocumentsDict[documentId] = updatedImageDocument;
};
